import { shallowEqual, useSelector } from 'react-redux'
import { Redirect, useParams } from 'react-router-dom'
import ContentLoader from '../global/loaders/ContentLoader'
import CheckoutPage from './CheckoutPage'
import GuestCheckoutBlockedModal from './GuestCheckoutBlockedModal'

const CheckoutAccessHandler = props => {
  const { shortCode: routeShortCode } = useParams()
  const { portal, currentUser, loading, checkoutSessionShortCode } = useSelector(
    state => ({
      portal: state.portal,
      currentUser: state.currentUser,
      loading: state.loading,
      checkoutSessionShortCode: state.checkoutSessionToken.shortCode
    }),
    shallowEqual
  )

  if (loading?.portal || !portal?.id) {
    return <ContentLoader />
  }

  if (!currentUser?.id && portal.checkout_mode === 'registered_only') {
    return <GuestCheckoutBlockedModal />
  }

  if (routeShortCode && checkoutSessionShortCode && routeShortCode !== checkoutSessionShortCode) {
    return <Redirect to={`/checkout/${checkoutSessionShortCode}`} />
  }

  return <CheckoutPage {...props} />
}

export default CheckoutAccessHandler
